import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./footer";

const Projectmanagment = () => {
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://billpunch.com/SeoBix/seo_injection.php?webid=9d59d8c77c932613971c6c6c6af12ce8&url=${encodedUrl}&baseUrl=https%3A%2F%2Fbillpunch.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      <Navbar />
      <h1 className="text-center mt-4 px-5 mx-5">
        Best Project Management Software in India 2025 – Plan, Execute & Deliver
        Projects Seamlessly
      </h1>
      <div className="d-flex justify-content-center">
        <img
          src="https://billpunch.com/billpunchImages/Peak%20Productivity.png"
          style={{ height: "50vh" }}
        />
      </div>
      <div className="row mt-md-2">
        <div className="col-md-1"></div>
        <div className="col-md-8">
          <h2>Working Out Planning and Executing Projects with Ease</h2>
          <p>
            Handling projects efficiently is absolutely crucial for the success
            of any business. Ideally, every software solution fulfills the basic
            functions of planning, executing, and monitoring a project for
            timely deliveries and resource maximization. Add to this dynamic
            project management software, and we trust the complete BillPunch
            Project Management software.From task assignments to budget
            tracking, this software is effectively suited for IT firms,
            construction companies, digital agencies, and enterprises.
          </p>

          <h5>
            Features of our Project Management Software Solutions provided by
            BillPunch
          </h5>

          <h5>Project Planning & Scheduling</h5>
          <ul>
            <li>Set project goals, milestones, and deadlines.</li>
            <li>
              Draw clear project roadmaps using Gantt charts and timeline views.
            </li>
          </ul>

          <h5>Team Collaboration & File Sharing</h5>
          <ul>
            <li>
              Real-time collaborative tools for a smooth collaboration among
              teams.
            </li>
            <li>Attach and manage documents inside project tasks.</li>
          </ul>
          <h5>Task Automation & Resource Management</h5>
<ul>
  <li>Automatically assign tasks based on workload and availability.</li>
  <li>Monitor staff productivity with real-time progress tracking.</li>
</ul>

<h5>Budgeting & Expense Tracking</h5>
<ul>
  <li>Control project expenses from overrunning budgets.</li>
  <li>Set up automatic invoicing and billing for projects built for clients.</li>
</ul>

<h5>Performance Analytics & Reports</h5>
<ul>
  <li>Monitor KPIs of projects with customizable reports.</li>
  <li>Understand efficiency and cost-effectiveness.</li>
</ul>

        </div>

        <div className="col-md-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Projectmanagment;
